import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  icon: IconType;
  size?: number;
  className?: string;
}

// react-icons v5 returns ReactNode but TS4 + @types/react 18.2 expects Element|null.
// This wrapper resolves the incompatibility in one place.
const Icon: React.FC<IconProps> = ({ icon, size, className }) =>
  React.createElement(icon as React.ComponentType<{ size?: number; className?: string }>, {
    size,
    className,
  });

export default Icon;
